import React from 'react';
import './LandingPage.css';
import bgImage from '../assets/landing-bg.jpg'; // ✅ Import image

const LandingPage = () => {
  return (
    <div
      className="landing-page"
      style={{ backgroundImage: `url(${bgImage})` }} // ✅ Set image via inline style
    >
      <div className="content">
        <h1>Houseplant Store</h1>
        <p>We offer a variety of beautiful indoor plants to brighten your home.</p>
        <button onClick={() => window.location.href = "/products"}>
          Get Started
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
